import { useQuery } from 'react-query';
import { localConfig } from '../../../Configs/localConfig';
import { errorAlert } from '../../../utils/alert';
import { getTalhao, TalhaoItens } from '..';

//=================================================================================>
// BUSCAR TALHÕES DE UMA PROPRIEDADE
//<=================================================================================

export const useGetTalhoesPorPropriedade = (cod_propriedade: number) => {

    const { conta, codCliente } = localConfig();

    const queryKey: any = [`talhoes_propriedade_${conta}_${codCliente}_${cod_propriedade}`];

    const { data, isFetching, refetch, isError } = useQuery<TalhaoItens[], Error>(queryKey, async () => {
        return getTalhao(cod_propriedade, '')
            .then((response) => {
                return (response?.data?.itens ?? []).map((item) => ({
                    ...item,
                    coordenadas: item?.kml?.coordenadas,
                })) as any;
            })
            .catch((error) => {
                errorAlert(error?.response?.data?.error ?? 'Falha ao obter talhões da propriedade!');
            });
    },
        {
            /**
             * Exige também o cliente: a URL do `getTalhao` monta `codCliente` a partir
             * do `localConfig`, e sem cliente no filtro global ele vai vazio — a API
             * responde erro e o `catch` dispara um alerta que o usuário não pode
             * resolver. Sem cliente, simplesmente não há talhão a buscar.
             */
            enabled: !!cod_propriedade && String(localConfig()?.codCliente ?? '') !== '',
            refetchOnWindowFocus: false,
        }
    );

    return {
        data_talhoes: data ?? [],
        carregando_talhoes: isFetching,
        refetch_talhoes: refetch,
        isError_talhoes: isError,
    };
};
